import { Component } from '@angular/core';

@Component({
  selector: 'app-book-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './book-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class BookIconComponent {}
